import { BUSINESS_ADMIN_HOST } from 'api/constants';

export const LOGIN_URL = `${BUSINESS_ADMIN_HOST}/v1/internal-users/login`;
export const PERMISSIONS_URL = `${BUSINESS_ADMIN_HOST}/v1/permissions`;
